module.exports = __webpack_public_path__ + "images/user-icon-white.svg";